module.exports = __webpack_public_path__ + "media/locales/_fr-78e9f99b.png";